export default __webpack_public_path__ + "static/media/fsi2.1a2bcd56.gif";